import { Autocomplete, Box, Card, Checkbox, FormControl, IconButton, InputLabel, MenuItem, Select, Tooltip } from '@mui/material'
import MDBox from 'components/MDBox'
import React, { useEffect, useState } from 'react'
import ModalMultiSelect from '../monitor-management/select-device'
import DataTable from 'examples/Tables/DataTable'
import DeleteIcon from "@mui/icons-material/Delete";
import CrudService from 'services/cruds-service'
import FormField from 'layouts/applications/wizard/components/FormField'
import MDTypography from 'components/MDTypography'
import MDDatePicker from 'components/MDDatePicker'
import { convertTo24HourRange } from 'utils/utils'
import moment from 'moment/moment'

function Thresholds({ selectedThresholds, setSelectedThresholds, type = null, model_id, setRequiredThresholds }) {

    const [tempDeviceThresholds, setTempDeviceThresholds] = useState([]);       // temp data to be displayed in data table of modal
    const [selectedThreRows, setSelectedThreRows] = useState([]);
    const [comparisonOperators, setComparisonOperators] = useState([]);
    const [thresholdTypes, setThresholdTypes] = useState([]);
    const [alertTypes, setAlertTypes] = useState([]);
    const [deviceModelParameter, setDeviceModelParameter] = useState([]);
    const [geofenceList, setGeofenceList] = useState([])

    useEffect(() => {

        (async () => {
            try {
                const response = await CrudService.getAllGeofences();
                let filter = []
                for (let i = 0; i < response.data.length; i++) {
                    const element = response.data[i];
                    filter.push({
                        title: `(#${element.geofence_id}) ${element.name} : Enter`,
                        value: `geofence_enter:${element.geofence_id}`
                    })
                    filter.push({
                        title: `(#${element.geofence_id}) ${element.name} : Inside`,
                        value: `geofence_inside:${element.geofence_id}`
                    })
                    filter.push({
                        title: `(#${element.geofence_id}) ${element.name} : Exit`,
                        value: `geofence_exit:${element.geofence_id}`
                    })
                }
                setGeofenceList(filter);

            } catch (err) {
                console.error(err);
                return null;
            }
        })();

        (async () => {
            try {
                const response = await CrudService.getThresholdTypes();
                setThresholdTypes(response.data);
            } catch (err) {
                console.error(err);
                return null;
            }
        })();

        (async () => {
            try {
                const response = await CrudService.getAlertTypes();
                setAlertTypes(response.data);
            } catch (err) {
                console.error(err);
                return null;
            }
        })();

        (async () => {
            try {
                const response = await CrudService.getComparisonOperators();
                setComparisonOperators(response.data);
            } catch (err) {
                console.error(err);
                return null;
            }
        })();

    }, []);

    useEffect(() => {
        (async () => {
            try {
                setDeviceModelParameter([])
                setTempDeviceThresholds([])
                setSelectedThresholds([])
                setSelectedThreRows([])
                setRequiredThresholds([])
                const response = await CrudService.getDeviceModelParameter(type, model_id);
                setDeviceModelParameter(response.data);
                setTempDeviceThresholds(response.data);
                if (type === 'create') {
                    let filter = response.data.filter((e) => e.show_on_create == 1).map((p) => p.DeviceParameter.parameter_id)
                    setSelectedThreRows([...filter])
                }
                if (setRequiredThresholds) {
                    let filterReuired = response.data.filter((e) => e.is_required == 1)
                    setRequiredThresholds(filterReuired)
                }
            } catch (err) {
                console.error(err);
                return null;
            }
        })();
    }, [model_id])

    useEffect(() => {
        const filteredThresholds = deviceModelParameter.filter(param => selectedThreRows.includes(param.id));
        for (let i = 0; i < filteredThresholds.length; i++) {
            let filtered = filteredThresholds[i]
            if (filtered?.default_value) {
                filtered.threshold_value = filtered.default_value;
            }
            if (filtered?.DeviceMonitorThresholdType) {
                filtered.threshold_type_id = filtered.DeviceMonitorThresholdType.id;
            }
            if (filtered?.ComparisonOperator) {
                filtered.comparison_operator_id = filtered.ComparisonOperator.id;
            }
            if (filtered?.AlertType) {
                filtered.alert_type_id = filtered.AlertType.alert_type_id;
            }
            if (filtered?.alert_enabled) {
                filtered.alert_enabled = true;
            }
            if (filtered?.event_enabled) {
                filtered.event_enabled = true;
            }
        }
        let updatedThresholds = [...selectedThresholds, ...filteredThresholds];
        updatedThresholds = JSON.parse(JSON.stringify(updatedThresholds))
        setSelectedThresholds(updatedThresholds);

        // const filteredRestThresholds = deviceModelParameter.map(item => item.DeviceParameter);
        setTempDeviceThresholds(deviceModelParameter);
    }, [selectedThreRows]);

    const removeThreshold = (index) => {
        const updatedThresholds = [...selectedThresholds];
        updatedThresholds.splice(index, 1);
        setSelectedThresholds(updatedThresholds);

        // const filteredRestParams = deviceModelParameter.map(item => item.DeviceParameter);
        setTempDeviceThresholds(deviceModelParameter);
    }

    const handlethresholdTypeChange = (index, NewThresholdType) => {
        const updatedDataTable = [...selectedThresholds];
        updatedDataTable[index].threshold_type_id = NewThresholdType?.id;
        updatedDataTable[index].DeviceMonitorThresholdType = NewThresholdType;
        setSelectedThresholds(updatedDataTable);
    };

    const handlethresholdValueChange = (index, value) => {
        const updatedDataTable = [...selectedThresholds];
        updatedDataTable[index].threshold_value = value;
        setSelectedThresholds(updatedDataTable);
    };

    const handlethresholdValueChangeForTimeRange = (index, value, pos) => {
        const updatedDataTable = [...selectedThresholds];
        let convert_value = ''
        let current_value = value
        let prev_value = updatedDataTable[index]?.threshold_value
        const parts = updatedDataTable[index]?.threshold_value?.split("-")
        if(parts?.length === 2){
            if(pos == 2){
                const time1 = moment(parts[0], 'h:mma'); // 4:00 PM
                const time2 = moment(current_value, 'h:mma'); // 5:00 PM
                if(!time1.isBefore(time2)){
                    return
                }
            }
            convert_value = pos === 1 ? `${current_value}-${parts[1]}` : `${parts[0]}-${current_value}`
        } else if(pos == 2 && prev_value){
            convert_value = `${parts[0]}-${current_value}`
        } else {
            convert_value = current_value
        }
        updatedDataTable[index].threshold_value = convert_value;
        setSelectedThresholds(updatedDataTable);
    };

    const handleThresholdOperatorChange = (index, NewComparisonOperator) => {
        const updatedDataTable = [...selectedThresholds];
        updatedDataTable[index].comparison_operator_id = NewComparisonOperator?.id;
        updatedDataTable[index].ComparisonOperator = NewComparisonOperator;
        setSelectedThresholds(updatedDataTable);
    };

    const handleAlertTypeChange = (index, NewAlertType) => {
        const updatedDataTable = [...selectedThresholds];
        updatedDataTable[index].alert_type_id = NewAlertType?.alert_type_id;
        updatedDataTable[index].AlertType = NewAlertType;
        setSelectedThresholds(updatedDataTable);
    };

    const handlealertEnabledChange = (index, value) => {
        const updatedDataTable = [...selectedThresholds];
        updatedDataTable[index].alert_enabled = value;
        setSelectedThresholds(updatedDataTable);
    };

    const handleeventEnabledChange = (index, value) => {
        const updatedDataTable = [...selectedThresholds];
        updatedDataTable[index].event_enabled = value;
        setSelectedThresholds(updatedDataTable);
    };

    const handleChange = (index, event) => {
        const { name, value } = event.target;
        const updatedDataTable = [...selectedThresholds];
        updatedDataTable[index].group_id = value;
        setSelectedThresholds(updatedDataTable);
    };

    const getRows = () => {
        return selectedThresholds.map((row, index) => {
            const fields = [
                {
                    parameter_name: row.DeviceParameter.parameter_name
                }
            ];

            if (row?.is_threshold_required || row?.DeviceParameter?.is_threshold_required) {
                fields.push(
                    {
                        group_id: (
                            <Select label="Group ID" name="group_id" value={row.group_id ?? null} onChange={(e) => handleChange(index, e)} sx={{ height: '40px' }}>
                                {
                                    selectedThresholds.length && selectedThresholds.map((elm, key) => (
                                        <MenuItem key={key} value={key + 1}>{key + 1}</MenuItem>
                                    ))
                                }
                            </Select>
                        ),
                        threshold_type: (
                            <Autocomplete
                                value={row?.DeviceMonitorThresholdType || null}
                                options={thresholdTypes}
                                getOptionLabel={(option) => (option ? option.threshold_name : "")}
                                isOptionEqualToValue={(option, value) => option.threshold_name === value?.threshold_name}
                                onChange={(event, NewThresholdType) => {
                                    handlethresholdTypeChange(index, NewThresholdType);
                                }}
                                style={{ width: "200px" }}
                                renderInput={(params) => (
                                    <FormField {...params} label="Type" InputLabelProps={{ shrink: true }} required />
                                )}
                            />
                        ),
                        threshold_value: (
                            <MDBox>
                                {
                                    row.DeviceParameter.parameter_name == 'geofence' ?
                                        <FormControl variant="standard" sx={{ color: '#fff', minWidth: '150px' }} required>
                                            <InputLabel id="threshold_value_label">Value</InputLabel>
                                            <Select
                                                labelId="threshold_value_label"
                                                id="threshold_value"
                                                name="threshold_value"
                                                value={row?.threshold_value || null}
                                                label="Threshold Value"
                                                onChange={(e) => handlethresholdValueChange(index, e.target.value)}
                                                sx={{
                                                    '& .MuiSelect-select': {
                                                        minHeight: '1em !important',
                                                        padding: '0 0.50rem 0 0 !important'
                                                    },
                                                    // width: '150px',
                                                    color: '#fff'
                                                }}
                                                autoWidth
                                            >
                                                {geofenceList.length > 0 && geofenceList.map((elm) => (
                                                    <MenuItem value={elm.value}>{elm.title}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                        :
                                        row.DeviceParameter.parameter_name == 'time_range' ?
                                            <Box sx={{ display: 'flex', gap: '0.5rem' }}>
                                                <MDDatePicker
                                                    value={row?.threshold_value}
                                                    onChange={(e) => handlethresholdValueChangeForTimeRange(index, moment(e[0]).format('h:mma'), 1)}
                                                    options={{
                                                        enableTime: true,
                                                        noCalendar: true,
                                                        dateFormat: "H:i",
                                                        parseDate: (datestr, format) => {
                                                            let date = convertTo24HourRange(datestr)
                                                            return Array.isArray(date) ? date[0] : date;
                                                        },
                                                    }}
                                                    required
                                                    input={{ placeholder: "Time", variant: "standard", className: 'time-picker-threshold', required: true }}
                                                />
                                                <MDDatePicker
                                                    value={row?.threshold_value}
                                                    onChange={(e) => handlethresholdValueChangeForTimeRange(index, moment(e[0]).format('h:mma'), 2)}
                                                    disabled={!row?.threshold_value}
                                                    options={{
                                                        enableTime: true,
                                                        noCalendar: true,
                                                        dateFormat: "H:i",
                                                        parseDate: (datestr, format) => {
                                                            let date = convertTo24HourRange(datestr)
                                                            return date[1];
                                                        },
                                                    }}
                                                    input={{ placeholder: "Time", variant: "standard", className: 'time-picker-threshold', disabled: !row?.threshold_value }}
                                                />
                                            </Box>
                                            // <TimeRangePicker disableClock={true}  />
                                            :
                                            <FormField
                                                required
                                                style={{ width: "150px" }}
                                                InputLabelProps={{ shrink: true }}
                                                value={row.threshold_value}
                                                label="Value"
                                                onChange={(e) => handlethresholdValueChange(index, e.target.value)}
                                            />
                                }
                                {row?.validationError && <div style={{ color: 'red' }}>{row?.validationError}</div>}
                            </MDBox>
                        ),
                        comparison_operator: (
                            <Autocomplete
                                value={row.ComparisonOperator || null}
                                options={comparisonOperators}
                                getOptionLabel={(option) => (option ? option.comparison_operator : "")}
                                isOptionEqualToValue={(option, value) => option.comparison_operator === value?.comparison_operator}
                                onChange={(event, NewComparisonOperator) => {
                                    handleThresholdOperatorChange(index, NewComparisonOperator);
                                }}
                                style={{ width: "50px" }}
                                renderInput={(params) => (
                                    <FormField {...params} label="Operator" InputLabelProps={{ shrink: true }} required />
                                )}
                            />
                        ),
                        alert_type: (
                            <Autocomplete
                                value={row?.AlertType || null}
                                options={alertTypes}
                                getOptionLabel={(option) => (option ? option.type_name : "")}
                                isOptionEqualToValue={(option, value) => option.type_name === value?.type_name}
                                onChange={(event, NewAlertType) => {
                                    handleAlertTypeChange(index, NewAlertType);
                                }}
                                style={{ width: "240px" }}
                                renderInput={(params) => (
                                    <FormField {...params} label="Alert Type" InputLabelProps={{ shrink: true }} required />
                                )}
                            />
                        ),
                        alert_enabled: (
                            <Checkbox
                                style={{ width: "40px" }}
                                checked={row?.alert_enabled}
                                onChange={(e) => handlealertEnabledChange(index, e.target.checked)}
                            />
                        ),
                        event_enabled: (
                            <Checkbox
                                style={{ width: "40px" }}
                                checked={row?.event_enabled}
                                onChange={(e) => handleeventEnabledChange(index, e.target.checked)}
                            />
                        )
                    }
                );
            }
            return Object.assign({}, ...fields);
        });
    };

    const getParamRows = (info) => {
        let updatedInfo = info.map((row) => {
            return {
                id: row.id,
                parameter_id: row.parameter_id,
                name: row.DeviceParameter.label,
                alert_type: row?.AlertType?.type_name,
                description: row.DeviceParameter.tooltip,
                type: row.DeviceParameter.FieldType?.name,
            };
        });
        return updatedInfo;
    }

    const tableThresholdData = {
        columns: [
            { Header: "Group ID", accessor: "group_id" },
            { Header: "Parameter Name", accessor: "parameter_name" },
            { Header: "Threshold Type", accessor: "threshold_type" },
            { Header: "Comparison Operator", accessor: "comparison_operator" },
            { Header: "Threshold Value", accessor: "threshold_value" },
            { Header: "Alert Type", accessor: "alert_type" },
            {
                Header: "Alert Enabled",
                accessor: 'alert_enabled'
            },
            {
                Header: "Event Enabled",
                accessor: 'event_enabled'
            },
            {
                Header: "actions",
                disableSortBy: true,
                accessor: "",
                Cell: (info) => {
                    return (
                        <MDBox display="flex" alignItems="center">
                            {(
                                <Tooltip title="Delete Parameter">
                                    <IconButton onClick={() => removeThreshold(info.cell.row.index)}>
                                        <MDTypography><DeleteIcon /></MDTypography>
                                    </IconButton>
                                </Tooltip>
                            )}
                        </MDBox>
                    );
                },
            }
        ],
        rows: getRows(),
    };

    const tableThresholdAllData = {
        columns: [
            { Header: "Id", accessor: "id" },
            { Header: "Parameter Id", accessor: "parameter_id" },
            { Header: "Name", accessor: "name" },
            { Header: "Alert Type", accessor: "alert_type" },
            { Header: "Description", accessor: "description" },
            { Header: "Type", accessor: "type" },
        ],
        rows: getParamRows(tempDeviceThresholds),
    };

    return (
        <Card style={{ marginTop: '1rem' }}>
            <MDBox display="flex" flexDirection="column" px={3} my={2}>
                <ModalMultiSelect table={tableThresholdAllData} selectedRows={selectedThreRows} setSelectedRows={setSelectedThreRows} label="Thresholds" />
                <DataTable table={tableThresholdData} canSearch={true} tableHeight="calc(100vh - 410px)" />
            </MDBox>
        </Card>
    )
}

export default Thresholds